import { render } from "./AppWrapper.vue?vue&type=template&id=835f33fc&scoped=true"
import script from "./AppWrapper.vue?vue&type=script&lang=js"
export * from "./AppWrapper.vue?vue&type=script&lang=js"

import "./AppWrapper.vue?vue&type=style&index=0&id=835f33fc&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835f33fc"]])

export default __exports__